





















































































































import { SelectAchievementImageModal } from '@/components/admin-panel/achievements';
import { AddAchievementForm } from '@/models/admin-panel';
import Vue from 'vue';
import { Actions } from '@/store';
import { ToastsService, resetModel, ImageMdSize, ImageSmSize, ImageLgSize, DisplayToggleOffset } from '@/utils';

export default Vue.extend({
  name: 'AchievementsAddTab',
  components: {
    SelectAchievementImageModal,
  },
  data() {
    return {
      requestStatusIconMap: {
        rejected: 'log-icon-close',
        pending: 'log-icon-pending',
        ordered: 'log-icon-pending',
        confirmed: 'log-icon-pending',
        accepted: 'log-icon-check',
      },
      loader: {
        isRequestPending: false,
      },
      form: {
        name: '',
        description: '',
        iconFile: null as unknown as Blob,
        iconFileData: '',
      },
      imageSmSize: {
        width: ImageSmSize.width,
        height: ImageSmSize.height,
      },
      imageMdSize: {
        width: ImageMdSize.width,
        height: ImageMdSize.height,
      },
      imageLgSize: {
        width: ImageLgSize.width,
        height: ImageLgSize.height,
      },
      url: '',
      isButtonMovedToRight: true,
      displayToggleOffset: DisplayToggleOffset,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.changeAddButtonPlace);
  },
  methods: {
    async addAchievement() {
      const isFormValid = await this.$validator.validate();
      if (!isFormValid) {
        return;
      }

      this.loader.isRequestPending = true;
      const reader = new FileReader();
      reader.readAsDataURL(this.form.iconFile);
      reader.onloadend = async () => {
        try {
          const base64data = (reader.result as string).split(',')[1];

          const formData: AddAchievementForm = {
            name: this.form.name,
            description: this.form.description,
            image: {
              bytes: base64data,
              imageType: this.form.iconFile.type.split('/')[1],
            },
            imageMdSize: this.imageMdSize,
            imageSmSize: this.imageSmSize,
            languageCode: this.$i18n.locale,
          };

          await this.$store.dispatch(Actions.achievements.addAchievement, formData);
          ToastsService.success(this.$t('admin-panel.achievements.tabs.add.achievement-added-toast') as string);
          this.resetModels();
        } finally {
          this.loader.isRequestPending = false;
        }
      };
    },
    resetModels() {
      this.form = resetModel(this.form);
      this.url = '';

      requestAnimationFrame(async () => await this.$validator.reset());
    },
    openUploadModal() {
      this.$bvModal.show('select-achievement-image-modal');
    },
    async onAchievementImageSelected(value: Promise<Blob>) {
      const blob = await value;

      this.form.iconFile = blob;
      this.url = URL.createObjectURL(blob);
    },
    changeAddButtonPlace() {
      return window.scrollY > this.displayToggleOffset
        ? (this.isButtonMovedToRight = false)
        : (this.isButtonMovedToRight = true);
    },
  },
});
